/**
 * United States dollar (next day).
 */
export var USN = {
  code: 'USN',
  base: 10,
  exponent: 2
};